if (!customElements.get("m-look-card")) {
  class MLookCard extends HTMLElement {
    constructor() {
      super();
      this.active = -1;
      this.ticking = false;
      this.onHotspotClick = this.onHotspotClick.bind(this);
      this.onArrowClick = this.onArrowClick.bind(this);
      this.onRailScroll = this.onRailScroll.bind(this);
      this.onRailFocusIn = this.onRailFocusIn.bind(this);
    }

    connectedCallback() {
      this.rail = this.querySelector(".m-look-card__rail");
      this.hotspots = Array.from(this.querySelectorAll(".m-look-card__hotspot"));
      this.items = Array.from(this.querySelectorAll(".m-look-card__product"));
      this.prevButton = this.querySelector(".m-look-card__arrow--prev");
      this.nextButton = this.querySelector(".m-look-card__arrow--next");
      this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (!this.rail || this.hotspots.length === 0 || this.items.length === 0) return;

      this.hotspots.forEach((hotspot) => hotspot.addEventListener("click", this.onHotspotClick));
      this.prevButton && this.prevButton.addEventListener("click", this.onArrowClick);
      this.nextButton && this.nextButton.addEventListener("click", this.onArrowClick);
      this.rail.addEventListener("scroll", this.onRailScroll, { passive: true });
      this.rail.addEventListener("focusin", this.onRailFocusIn);

      this.setActive(0);
    }

    disconnectedCallback() {
      this.hotspots.forEach((hotspot) => hotspot.removeEventListener("click", this.onHotspotClick));
      this.prevButton && this.prevButton.removeEventListener("click", this.onArrowClick);
      this.nextButton && this.nextButton.removeEventListener("click", this.onArrowClick);
      if (this.rail) {
        this.rail.removeEventListener("scroll", this.onRailScroll);
        this.rail.removeEventListener("focusin", this.onRailFocusIn);
      }
    }

    onHotspotClick(event) {
      const index = Number(event.currentTarget.dataset.index);
      this.scrollToIndex(index);
      this.setActive(index);
    }

    onArrowClick(event) {
      const dir = Number(event.currentTarget.dataset.dir);
      const index = this.active + dir;
      if (index < 0 || index >= this.items.length) return;
      this.scrollToIndex(index);
      this.setActive(index);
    }

    onRailFocusIn(event) {
      const item = event.target.closest(".m-look-card__product");
      if (!item) return;
      this.setActive(Number(item.dataset.index));
    }

    onRailScroll() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.syncActiveFromScroll();
        this.ticking = false;
      });
    }

    syncActiveFromScroll() {
      const railLeft = this.rail.getBoundingClientRect().left;
      let closest = 0;
      let smallestDistance = Infinity;

      this.items.forEach((item, index) => {
        const distance = Math.abs(item.getBoundingClientRect().left - railLeft);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closest = index;
        }
      });

      this.setActive(closest);
    }

    scrollToIndex(index) {
      const item = this.items[index];
      if (!item) return;
      const left = item.offsetLeft - this.rail.offsetLeft;
      this.rail.scrollTo({ left, behavior: this.reduceMotion ? "auto" : "smooth" });
    }

    setActive(index) {
      if (index === this.active || index < 0 || index >= this.items.length) return;
      this.active = index;

      this.hotspots.forEach((hotspot, n) => {
        const isActive = n === index;
        hotspot.classList.toggle("is-active", isActive);
        hotspot.setAttribute("aria-current", isActive ? "true" : "false");
      });

      this.items.forEach((item, n) => item.classList.toggle("is-active", n === index));

      if (this.prevButton) this.prevButton.disabled = index === 0;
      if (this.nextButton) this.nextButton.disabled = index === this.items.length - 1;
    }
  }

  customElements.define("m-look-card", MLookCard);
}

if (!customElements.get("m-look-track")) {
  class MLookTrack extends HTMLElement {
    constructor() {
      super();
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.rail = this.querySelector(".m-look-track__rail");
      if (!this.rail) return;

      document.addEventListener("shopify:block:select", this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }

    onBlockSelect(event) {
      const target = event.target;
      if (!target || !target.dataset || !target.dataset.blockId || !this.contains(target)) return;
      this.rail.scrollTo({ left: target.offsetLeft - this.rail.offsetLeft, behavior: "smooth" });
    }
  }

  customElements.define("m-look-track", MLookTrack);
}

// Add-to-cart itself needs no extra JS here — snippets/look-card-product.liquid wraps its form in
// the shared <product-form> custom element (assets/theme-global.js), which already does the AJAX
// submit, opens the cart drawer, and dispatches cart:updated/product-ajax:added.
